module.exports = __webpack_public_path__ + "img/driver-signup-main.46fc6681.svg";